import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppTermsAndConditionsService } from 'src/app/service/cookie.service';

@Component({
  selector: 'app-login-aggreement',
  templateUrl: './login-aggreement.component.html',
  styleUrls: ['./login-aggreement.component.scss']
})
export class LoginAggreementComponent implements OnInit {

  termsAccepted = false;

  @ViewChild('termsContent') termsContent!: ElementRef;

  constructor( public dialogRef: MatDialogRef<LoginAggreementComponent>,private cookieService: AppTermsAndConditionsService) { }

  ngOnInit(): void {
  }

  acceptTerms() {
    console.log('Terms accepted!');
    this.cookieService.setConsentCookie();
    this.dialogRef.close(true)
  }

onCancel(){
  this.dialogRef.close(false)
}
}